import { onError } from '@apollo/client/link/error';
import type { ValidationErrorHandler } from '../../utils/error/handleUnknownApolloErrors';
import handleUnknownApolloErrors from '../../utils/error/handleUnknownApolloErrors';

const getErrorLink = ({
  handleValidationError,
}: {
  handleValidationError: ValidationErrorHandler;
}) => {
  return onError((apolloError) => {
    handleUnknownApolloErrors({
      error: apolloError,
      prefix: 'Apollo',
      handleValidationError,
    });
  });
};

export default getErrorLink;
